import wretch from "wretch";

export interface DealerLogo {
  fileName: string;
  hasCustomPadding: boolean;
  alt: string;
  businessName?: string;
  url?: string;
}
export interface DealerLogoData {
  primary: DealerLogo[];
  secondary: DealerLogo[];
}

export const EXCLUDED_LOGOS = [
  "moto3_logo_BA.webp",
  "bikeworld_logo_BA.webp",
  "motokeskus_logo_BA.webp",
  "gpgarageoy_logo_BA.webp"
];

export const isDealerLogoData = (data: unknown): data is DealerLogoData => {
  return (
    typeof data === "object" &&
    data !== null &&
    !Array.isArray(data) &&
    "primary" in data &&
    "secondary" in data &&
    Array.isArray(data.primary) &&
    Array.isArray(data.secondary)
  );
};

const DEALER_LOGOS_URL = import.meta.env.VITE_FRONTPAGE_DEALER_LOGOS_URL;
const LOGOS_LIST_FILENAME = import.meta.env.VITE_FRONTPAGE_DEALER_LOGOS_LIST;
const PRIMARY_LOGOS_PATH = import.meta.env
  .VITE_FRONTPAGE_DEALER_LOGOS_PRIMARY_PATH;
const SECONDARY_LOGOS_PATH = import.meta.env
  .VITE_FRONTPAGE_DEALER_LOGOS_SECONDARY_PATH;

export const getPadding = (isMobile: boolean, hasCustomPadding: boolean) => {
  if (isMobile) {
    return hasCustomPadding ? 1 : 0;
  } else {
    return hasCustomPadding ? 2 : 0;
  }
};

export const getLogoUrl = (type: "primary" | "secondary", fileName: string) => {
  if (type === "primary") {
    return `${DEALER_LOGOS_URL}${PRIMARY_LOGOS_PATH}${fileName}`;
  } else {
    // type === "secondary"
    return `${DEALER_LOGOS_URL}${SECONDARY_LOGOS_PATH}${fileName}`;
  }
};

export const getDealerLogoData = async () => {
  try {
    const url = `${DEALER_LOGOS_URL}${LOGOS_LIST_FILENAME}`;
    return wretch(url)
      .headers({
        "cache-control": "public, max-age=3600"
      }) // instructs CDN to cache for 1 hour
      .get()
      .json();
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const shuffle = <T>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
